




































































































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { DamageStatus, IDamage } from 'admiral-core';
import {
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  Edit2Icon,
  MoreVerticalIcon,
  MoreHorizontalIcon,
  PlusIcon,
  StarIcon,
  TrashIcon,
} from 'vue-feather-icons';
import 'vue-select/dist/vue-select.css';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import Avatar from '@/components/common/Avatar.vue';
import Multiselect from 'vue-multiselect';
import { FormatMixin } from '@/mixins/FormatMixin';
import EditDamageModal from '@/views/pages/damages/EditDamageModal.vue';
import { DamageApi } from '@/services/DamageApi';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import draggable from 'vuedraggable';
import DamageListItem from '@/components/common/DamageListItem.vue';

type SectionKey = 'new' | 'inProgress' | 'pending' | 'submitted' | 'completed' | 'declined';

@Component({
  components: {
    DamageListItem,
    EditDamageModal,
    PlusIcon,
    StarIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    MoreVerticalIcon,
    MoreHorizontalIcon,
    Edit2Icon,
    TrashIcon,
    Avatar,
    Multiselect,
    CheckIcon,
    draggable,
  },
})
export default class DamageOverview extends mixins(BaseMixin, FormatMixin, PermissionMixin) {
  @Prop({ required: true, type: Array })
  damages!: IDamage[];

  drag = false;
  damageStatus = DamageStatus;

  expandedSections: Record<SectionKey, boolean> = {
    new: true,
    inProgress: true,
    pending: true,
    submitted: true,
    completed: true,
    declined: true,
  };

  onReload() {
    this.$emit('reload');
  }

  toggleExpanded(section: SectionKey) {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  updatedDamage(damage: IDamage) {
    this.$emit('update-damage', damage);
  }

  get groupedDamages(): Partial<Record<DamageStatus, IDamage[]>> {
    const groups: Partial<Record<DamageStatus, IDamage[]>> = {
      [DamageStatus.NEW]: [],
      [DamageStatus.IN_PROGRESS]: [],
      [DamageStatus.PENDING]: [],
      [DamageStatus.SUBMITTED]: [],
      [DamageStatus.COMPLETED]: [],
      [DamageStatus.DECLINED]: [],
      [DamageStatus.DELETED]: [],
    };
    for (const d of this.damages) {
      if (groups[d.status]) {
        groups[d.status]!.push(d);
      }
    }
    for (const arr of Object.values(groups)) {
      if (arr) arr.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }
    return groups;
  }

  async onDragEnd(evt: any) {
    if (evt.oldDraggableIndex === evt.newDraggableIndex && evt.from === evt.to) return;

    const movedId = (evt.item as HTMLElement).dataset.damageId!;
    const moved = this.damages.find((d) => d.id === movedId)!;
    const newStatus = (evt.to as HTMLElement).dataset.status as DamageStatus;
    const newIndex = evt.newDraggableIndex; // Ziel-Index (0-basiert)

    const listFull = this.groupedDamages[newStatus];
    if (!listFull) return;
    const list = listFull.filter((d) => d.id !== movedId);

    const prev = list[newIndex - 1]?.order;
    const next = list[newIndex]?.order;

    let newOrder: number;
    if (!prev && !next) newOrder = 1;
    else if (!prev) newOrder = next! / 2;
    else if (!next) newOrder = prev + 1;
    else newOrder = (prev + next) / 2;

    this.$set(moved, 'status', newStatus);
    this.$set(moved, 'order', newOrder);

    await this.$nextTick();

    try {
      const res = await DamageApi.move(moved.id, { status: newStatus, order: newIndex });
      this.$set(moved, 'order', res.data.order);
    } catch (e) {
      this.$toastr.e('Verschieben fehlgeschlagen');
      this.$emit('reload');
    }
  }
}
